<template>
  <div class="view-order-wrap">
      <img src="@/assets/img/view-order-img.png" class="view-img"/>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  async mounted() {
    if (this.$route.query.toast) {
      this.$toast(this.$route.query.toast)
    }
  },
  methods: {
    
  }
};
</script>

<style lang="scss">
.view-order-wrap .view-img {
  width: 100%;
  display: block;
}
</style>
